// import banner from "../assets/images/iq_banner.jpeg";
import "./Terms.css";

const ItcPortal = () => {
  return (
    <div className="tandc-page">
      <div className="tandc">
        {/* Banner */}
        {/* <div className="tandc-banner-wrapper" align="center">
          <img
            src={banner}
            alt="Open Your  Banner"
            className="tandc-banner"
          />
        </div> */}
        {/*  Page Heading */}
        {/* <h3 className="page-title" align="center">
          “Open Your (“CAMPAIGN”)
        </h3> */}
        {/* Heading */}
        <h4 className="page-sub-title" align="center">
          Terms and Conditions
        </h4>

        {/* Sub Heading */}
        <div>
          <ol>
            <li>
              This activity will start on 15th June,2026 and end on 31st
              August,2026. No entry or registration will be entertained after,
              31st August 2026.
            </li>
            <li>
              This activity is open only to persons of age 18 (eighteen) years
              and above, as on, 15th June 2026. Participation in this activity
              is purely voluntary. Participation in this activity implies
              acceptance of these terms and conditions.
            </li>
            <li>This activity is valid only for the state of Tamil Nadu.</li>
            <li>
              Any participation received from the residents outside of the state
              of Tamil Nadu will not be considered. Participation in this
              activity will be treated as void ab initio wherever such
              activities are specifically prohibited under local laws.
            </li>
            <li>
              Participants will win Rs. 50/- on purchase of this package and
              participation in this activity. To redeem the cash amount printed
              on the packaging insert, the participant needs to show a valid
              proof of age, identity and surrender the original packaging insert
              to the shopkeeper on or before 31st August 2026.
            </li>
            <li>
              The participant will be paid only the amount which is mentioned on
              the Packaging Insert. No additional claim will be entertained.
            </li>
            <li>A damaged or illegible packaging insert will be rejected.</li>
            <li>
              ITC Limited <strong>(“ITC”)</strong> reserves the right to reject the claim if any
              of the terms or conditions are not met. ITC will not be liable in
              any manner for any claim arising out of or in respect of this
              activity.
            </li>
            <li>
              ITC unilaterally reserves the right to change the terms and
              conditions of this activity including extending, withdrawing or
              discontinuing the same without notice or assigning any reason, at
              its sole discretion and without any liability.
            </li>
            <li>
              Employees of ITC and their family members are not eligible to
              participate in this activity.
            </li>
            <li>
              All disputes are subject to the exclusive jurisdiction of the
              courts at Kolkata.
            </li>
            <li>
              This activity shall be governed by the privacy policy of ITC,
              published here
            </li>
            <a href="https://www.itcportal.com/about-itc/policies/privacy-policy.aspx">
              https://www.itcportal.com/about-itc/policies/privacy-policy.aspx
            </a>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default ItcPortal;
